var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"discord-author-info"},[_c('span',{staticClass:"discord-author-username",style:({ color: _vm.roleColor })},[_vm._t("default")],2),(_vm.bot)?_c('span',{staticClass:"discord-bot-tag"},[_vm._v(" Bot ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }